import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const HRAOFMI_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/hraofmi/logo.png",
        alt: "Heron Ridge Associates Logo",
        style: { width: "230px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 44,
  state: "MI",
  departmentIds: [203, 230, 232, 240, 253],
};
